import { useQuery } from '@tanstack/react-query'
import { MEMBERS } from '../constants/endpoints'
import { getMembers } from '../utils/getMembers'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useMembersQuery = ({ enabled }: { enabled: boolean }) => {
  const userId = useAuthStore((state) => state.user?._id)

  return useQuery({
    queryKey: [MEMBERS, userId],
    queryFn: getMembers,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
